import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { ResourceRequestMethod, ResourceResponseBodyType } from '@ngx-resource/core';
import { ResourceHandlerAbstract } from './ResourceHandlerAbstract';
var ResourceHandlerHttpClient = /** @class */ (function (_super) {
    __extends(ResourceHandlerHttpClient, _super);
    function ResourceHandlerHttpClient(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    ResourceHandlerHttpClient.prototype.request = function (request) {
        return this.http
            .request(request)
            .pipe(filter(function (resp) { return resp.type === HttpEventType.Response; }));
    };
    ResourceHandlerHttpClient.prototype.prepareRequest = function (req) {
        var method = 'GET';
        switch (req.method) {
            case ResourceRequestMethod.Get:
                method = 'GET';
                break;
            case ResourceRequestMethod.Post:
                method = 'POST';
                break;
            case ResourceRequestMethod.Put:
                method = 'PUT';
                break;
            case ResourceRequestMethod.Delete:
                method = 'DELETE';
                break;
            case ResourceRequestMethod.Head:
                method = 'HEAD';
                break;
            case ResourceRequestMethod.Options:
                method = 'OPTIONS';
                break;
            case ResourceRequestMethod.Patch:
                method = 'PATCH';
        }
        var init = {
            withCredentials: req.withCredentials
        };
        switch (req.responseBodyType) {
            case ResourceResponseBodyType.Json:
                init.responseType = 'json';
                break;
            case ResourceResponseBodyType.ArrayBuffer:
                init.responseType = 'arraybuffer';
                break;
            case ResourceResponseBodyType.Blob:
                init.responseType = 'blob';
                break;
            default:
                init.responseType = 'text';
        }
        if (req.headers) {
            init.headers = new HttpHeaders(req.headers);
        }
        if (req.query) {
            init.params = new HttpParams({ fromObject: req.query });
        }
        return new HttpRequest(method, req.url, req.body, init);
    };
    ResourceHandlerHttpClient.prototype.handleResponse = function (req, response) {
        var headers = {};
        var keys = response.headers.keys();
        keys.forEach(function (key) {
            headers[key] = response.headers.getAll(key);
        });
        return {
            status: response.status,
            body: response.body || response.error,
            headers: headers
        };
    };
    /** @nocollapse */
    ResourceHandlerHttpClient.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
ResourceHandlerHttpClient.ɵfac = function ResourceHandlerHttpClient_Factory(t) { return new (t || ResourceHandlerHttpClient)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
ResourceHandlerHttpClient.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ResourceHandlerHttpClient, factory: function (t) { return ResourceHandlerHttpClient.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResourceHandlerHttpClient, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();
    return ResourceHandlerHttpClient;
}(ResourceHandlerAbstract));
export { ResourceHandlerHttpClient };

